// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1tFsY","footer":"ModalUpdate_footer__1LHgv"};